import { useContext } from "react";
import { OwnerModuleContext } from "../context";
import { ModuleInfo } from "../model";

/**
 * Returns the module that owns the calling component.
 */
export function useOwnerModule(): ModuleInfo | null {
  const info = useContext<ModuleInfo | null>(OwnerModuleContext);
  return info;
}
